import { Stack, Theme, Typography } from '@mui/material'
import styled from 'styled-components'

export const DriverContainer = styled(Stack)`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const DriverName = styled(Typography)<{ theme: Theme }>`
  font-size: 14px !important;
  line-height: 1.35 !important;
  background-color: ${({ theme }) => theme.palette.secondary.main};
  color: ${({ theme }) => theme.palette.common.white};
  font-weight: 700 !important;
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 10px;
  padding-right: 10px;
  border-radius: 5px;
`
